import { Module } from 'vuex'
import { state } from './state'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { RootState } from 'store'
import { TimeSheetTrackingState } from './types'

export const timeSheetTracking: Module<TimeSheetTrackingState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}